import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateANewResourceForLanguage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Resources/AddResourceDetailToResourceByLanguageId");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class GetAllResources extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Resources/GetAllResource");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetResourceDetailsById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Resources/GetResourceDetailsById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetResourceDetailsContentById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag(
      "Resources/GetResourceDetailContentSectionsByResourceDetailsId"
    );
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class RemoveResourceDetailById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Resources/RemoveResourceDetailById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class RemoveResourceAttachmentById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Resources/RemoveResourceDetailContentSectionAttachmentById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateResourceDetailContent extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Resources/CreateResourceDetailContentSection");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class UploadAttachmentToResourceDetailSection extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag(
      "Resources/UploadAttachmentsToResourceDetailContentSectionById"
    );
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class RemoveResourceDetailContentSection extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag(
      "Resources/RemoveResourceDetailContentSectionByResourceDetailContentSectionId"
    );
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateResourceDetailContentSection extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Resources/UpdateResourceDetailContentSectionsById");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class UpdateResource extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Resources/UpdateResourceDetailById");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

export {
  UploadAttachmentToResourceDetailSection,
  CreateANewResourceForLanguage,
  CreateResourceDetailContent,
  GetAllResources,
  GetResourceDetailsById,
  GetResourceDetailsContentById,
  RemoveResourceDetailById,
  RemoveResourceAttachmentById,
  RemoveResourceDetailContentSection,
  UpdateResourceDetailContentSection,
  UpdateResource,
};
